import { Component, HostListener} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrl: './home-one.component.css'
})
export class HomeOneComponent {
  
  //Services
  services = [
    {
      icon: 'bi bi-chat-dots',
      title: 'IT Consulting',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.',
      marginTop: true
    },
    {
      icon: 'bi bi-code-slash',
      title: 'App Development',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.',
      marginTop: false
    },
    {
      icon: 'bi bi-upc-scan',
      title: 'AI Agents',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.',
      marginTop: true
    }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  //Brand Logos
  brands = [
    { image: 'assets/images/brands/brand-1.png', alt: 'brand-1' },
    { image: 'assets/images/brands/brand-2.png', alt: 'brand-2' },
    { image: 'assets/images/brands/brand-3.png', alt: 'brand-3' },
    { image: 'assets/images/brands/brand-4.png', alt: 'brand-4' },
    { image: 'assets/images/brands/brand-5.png', alt: 'brand-5' },
    { image: 'assets/images/brands/brand-6.png', alt: 'brand-6' }
  ];

  brandCarouselOptions = {
    loop: true,
    margin: 50,
    autoplay: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 3 },
      992: { items: 5 },
      1200: { items: 5 }
    }
  };

  // Funfacts
  funFacts =[
    {
      number: 2530,
      desc: "Working Hours",
      displayedNumber: 0
    },
    {
      number: 100,
      desc: "Photo Capture",
      displayedNumber: 0
    },
    {
      number: 100,
      desc: "Project Completed",
      displayedNumber: 0
    },
    {
      number: 300,
      desc: "Telephonic Talk",
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  // Skills
  skills = [
    { name: 'Social Marketing', level: 94 },
    { name: 'Sales Training', level: 88 },
    { name: 'Copywriting', level: 92 }
  ];

  isScrolled = false;

  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 2,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: "Roland Buford",
      subtitle: "CEO/Founder",
      image: "client-1-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "Karl Casey",
      subtitle: "Photography",
      image: "client-2-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "David Marks",
      subtitle: "Web Developer",
      image: "client-3-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "Lynda Stone",
      subtitle: "Project Lead",
      image: "client-4-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }

  ];

  // Clients
  clients = [
    { img: 'assets/images/brands/brand-1.png', alt: '01' },
    { img: 'assets/images/brands/brand-2.png', alt: '02' },
    { img: 'assets/images/brands/brand-3.png', alt: '03' },
    { img: 'assets/images/brands/brand-4.png', alt: '04' },
    { img: 'assets/images/brands/brand-5.png', alt: '05' },
    { img: 'assets/images/brands/brand-6.png', alt: '06' }
  ];

  //Team
  teams = [
    {
      img: 'team-1.jpg',
      name: 'Alexander Harvard',
      designation: 'Co Founder'
    },
    {
      img: 'team-2.jpg',
      name: 'Jemmy Watson',
      designation: 'Designer'
    },
    {
      img: 'team-3.jpg',
      name: 'Bobby Castro',
      designation: 'Project Lead'
    },
    {
      img: 'team-4.jpg',
      name: 'Luara Prior',
      designation: 'Data Scientist'
    }
  ];
  socialLinks = [
    { url: '#', class: 'text-light', icon: 'bi bi-facebook' },
    { url: '#', class: 'text-light', icon: 'bi bi-twitter-x' },
    { url: '#', class: 'text-light', icon: 'bi bi-pinterest' }
  ];

  //Works
  works = [
    {
      img: 'gallery-1.jpg',
      title: 'Digital Food',
      category: 'Branding'
    },
    {
      img: 'gallery-2.jpg',
      title: 'Astronaut',
      category: 'UX Design'
    },
    {
      img: 'gallery-3.jpg',
      title: 'Poster',
      category: 'Media'
    },
    {
      img: 'gallery-4.jpg',
      title: 'Blue Berry',
      category: 'Illustration, Media'
    },
    {
      img: 'gallery-5.jpg',
      title: 'Ten Branding',
      category: 'Branding, UX Design'
    },
    {
      img: 'gallery-6.jpg',
      title: 'Digi Veg',
      category: 'Branding'
    }
  ];

  //Pricing Plans
  pricingPlans = [
    {
      title: 'Personal',
      price: '29.99',
      period: 'monthly',
      features: [
        'Unlimited User',
        'Unlimited Storage',
        '24/7 Support',
        'Future Updates'
      ],
      extraClass: ''  // For first box
    },
    {
      title: 'Team',
      price: '49.99',
      period: 'monthly',
      features: [
        'Unlimited User',
        'Unlimited Storage',
        '24/7 Support',
        'Future Updates'
      ],
      extraClass: 'mt-lg-4' // For second box
    }
  ];

}
